import { BaseService } from '@colescba/services'

export class AANConsultasService extends BaseService {
  
  async getResultadoSolicitud(numeroTramite){
    const response = await this.http.get(`/aan-externos/tramites-estados/${numeroTramite}`)
    return response.data
  
  }
}
